<template>
  <div>
    <PageMain
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @reload="getData()"
      @edit-reload="$emit('reload')"
    >
      <template #header>
        <div class="d-flex align-items-stretch">
          <div class="side-frame"></div>
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_header_title_sku') || '订单产品明细' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="chooseVisible = true"
              v-if="!disabled"
            >
              {{ $l('btn_selectGoods') || '选择产品' }}
            </b-button>
          </div>
        </div>
      </template>
      <template #toolbar_btn>
        <SortFieldsPopover
          v-model="sortFields"
          funcListName="ftyPurchaseDetailList"
          style="margin-right: 0.8em;"
          @change="getData"
        />
      </template>
    </PageMain>

    <ChooseEvgSku
      :visible.sync="chooseVisible"
      :evgPurchaseCode="evgPurchaseCode"
      :currencyUnit="currencyUnit"
      @confirm="chooseConfirm"
    />
  </div>
</template>
<script>
import PageMain from './main'
import ChooseEvgSku from '../choose-evg-sku'
import EditLoading from '@/mixins/edit-loading'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'
export default {
  components: { PageMain, ChooseEvgSku, SortFieldsPopover },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    evgPurchaseCode: { type: String, default: '' },
    currencyUnit: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      chooseVisible: false,
      sortFields: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.evgPurchaseCode) return
      this.loading = true
      const params = {
        evgPurchaseCode: this.evgPurchaseCode,
        sortFields: this.sortFields,
      }
      const res = await this.$api
        .ecomEvgPurchaseDetailListApi(params)
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data || []
    },
    async chooseConfirm(data) {
      if (!data?.length) return

      const listEvgSkuFtyCode = data.map((item) => item.evgSkuFtyCode)
      const params = {
        evgPurchaseCode: this.evgPurchaseCode,
        listEvgSkuFtyCode,
      }
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgPurchaseDetailAddApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
